import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 6.76l-2 2V4h-9v5H5v11h14v-2.76l2-2v5.77a1 1 0 01-1 .99H4a1 1 0 01-1-1V8l6-6h11a1 1 0 011 1v3.76z"/>
    <path fill="#34CEFF" d="M23.2 10.22l-1.42-1.41L14 16.59v1.4l1.41.01 7.78-7.78z"/>
  </SvgIcon>
);